<template>
  <div class="smaller-container-wrapper full-height">
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <h2 class="mb-3 mb-sm-4">
        {{ $t(`message.eCommerceV2.finance.incomeAmountForm.${incomeDetailsMethod}Heading`) }}
      </h2>
      <div class="row form-row">
        <template v-if="incomeDetailsMethod === 'hourly'">
          <div class="col-sm-6">
            <mobialis-text-input-with-validation
              rules="required|decimal:2"
              :label="$t('message.eCommerceV2.finance.incomeAmountForm.hourlyWage')"
              v-model="hourlyWage"
              :mask-type="languageCode === 'fr-CA' ? 'frenchInt' : 'money'"
              inputmode="decimal"
              vid="hourlyWage"
              data-cy="hourlyWage"
            ></mobialis-text-input-with-validation>
          </div>
          <div class="col-sm-6">
            <mobialis-text-input-with-validation
              rules="required"
              :label="$t('message.eCommerceV2.finance.incomeAmountForm.hoursPerWeek')"
              v-model="hoursPerWeek"
              mask-type="naturalNumbers"
              inputmode="numeric"
              pattern="[0-9]*"
              vid="hoursPerWeek"
              data-cy="hoursPerWeek"
            ></mobialis-text-input-with-validation>
          </div>
        </template>
        <div v-else-if="incomeDetailsMethod === 'monthly'" class="col-6">
          <mobialis-text-input-with-validation
            rules="required|decimal:2|max_value:8333333"
            :label="$t('message.eCommerceV2.finance.incomeAmountForm.monthlyIncome')"
            v-model="monthlyIncome"
            :mask-type="languageCode === 'fr-CA' ? 'frenchInt' : 'money'"
            inputmode="decimal"
            vid="monthlyIncome"
            data-cy="monthlyIncome"
          ></mobialis-text-input-with-validation>
        </div>
        <div v-else class="col-6">
          <mobialis-text-input-with-validation
            rules="required|decimal:2|max_value:99999999"
            :label="$t('message.eCommerceV2.finance.incomeAmountForm.annualIncome')"
            v-model="annualIncome"
            :mask-type="languageCode === 'fr-CA' ? 'frenchInt' : 'money'"
            inputmode="decimal"
            vid="annualIncome"
            data-cy="annualIncome"
          ></mobialis-text-input-with-validation>
        </div>
      </div>
      <div class="push-down-desktop">
        <mobialis-button type="submit" class="mt-5 mb-3" data-cy="continue">{{
          $t('message.common.continue')
        }}</mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import { IncomeExpenses } from '@/mixins';

export default {
  name: 'IncomeAmountForm',
  mixins: [IncomeExpenses],
  methods: {
    submit(isValid) {
      if (!isValid) {
        return;
      }
      this.updateIncome();
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped></style>
